
import React, { useState } from "react";
import Select from "react-select";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import ls from 'localstorage-slim';
import { getCurrentLanguageTexts } from "../../../../constants/seasonPassPersonalInfoLangs";
import axios from "../../../../axios-instance";
import { getCustomURLs } from "../../../../helpers/getCustomURLs";
import { toast } from "react-toastify";

export const MySwal = withReactContent(Swal);

export const SelectAnotherHoldedSeatModal = ({ membershipId, seatLabel, holdedSeats }) => {
    const txt = getCurrentLanguageTexts();
    const [seat, setSeat] = useState(null);

    const token = ls.get('member-access-token')

    const selectAnotherSeatHandler = async () => {
        try {
            await axios.put(getCustomURLs().API_URL + `/Membership/holdedSeat/${membershipId}/changeTarget?accessToken=${token}&seatLabel=${seat.value}`);

            toast.success(txt.generalTxt.successOperation);
            window.location.reload();
        } catch (error) {
            toast.error(error.response.data)
        }
    };

    var seatOptions = holdedSeats.map(i => {
        return {
            value: `${i.area}-${i.side}-${i.row}-${i.seat}`,
            label: `${i.area} ${i.side} ${i.row} ${i.seat}`,
        }
    });

    return <div className="buy-membership-modal" >
        <div style={{ minHeight: '150px' }}>
            <label>
                {txt.SelectAnotherHoldedSeatModalTxt['description']}
            </label>
            <Select
                options={seatOptions}
                placeholder={txt.SelectAnotherHoldedSeatModalTxt['placeholder']}
                name='selectSeat'
                classNamePrefix="custom-select"
                className="seasonpass__select searchPanel__select"
                value={seat}
                onChange={setSeat}
            />
        </div>

        <section className='swal2-actions'>

            <button className="swal2-cancel swal2-styled"
                onClick={() => MySwal.close()}>
                {txt.generalTxt['cancel']}
            </button>
            <button disabled={seat ? undefined : true} className="swal2-confirm swal2-styled"
                onClick={selectAnotherSeatHandler}>
                {txt.generalTxt['save']}
            </button>

        </section>
    </div>;
};
